const supportTypeMapping = {
  courseSupport: 'Course',
  internalSupport: 'Internal Support',
};

const getSupportTypeName = type => supportTypeMapping[type] || 'Support';

export { getSupportTypeName };
